import { PlanTemplateType } from "../../templates/generated/template_types";
import type { PlaniraTemplate } from "../../templates/types";
import {
  ModuleDoneType,
  ModuleType,
  PlanQuestionType,
  PlanType,
} from "../../templates/types";

export const TravelTimeTemplate: PlaniraTemplate = {
  planType: PlanType.Planira,
  type: PlanTemplateType.TravelTime,
  title: "Travel plan",
  description: "Planning a trip? Get assistance with the where, when, and how.",
  longDescription: "",
  emoji: "🌎",
  titleHelp: "Miami trip, Dave's bachelor party, Summer vacation 2025...",
  image: require("../../assets/illustrations/Travelers-bro.svg"),
  sections: [
    {
      section: {
        isExpandable: false,
        isDraggable: false,
      },
      modules: [
        {
          type: ModuleType.PlanInfo,
          doneType: ModuleDoneType.None,
          title: "My travel plan",
          isDraggable: false,
          emoji: "",
        },
      ],
    },

    {
      section: {
        title: "Ongoing",
      },
      modules: [
        {
          type: ModuleType.Location,
          doneType: ModuleDoneType.Onboarding,
          title: "Where?",
          emoji: "🌎",
          questionOption: {
            question: "Do you know where you're going?",
            questionType: PlanQuestionType.Location,
          },
        },
        {
          type: ModuleType.Calendar,
          doneType: ModuleDoneType.Onboarding,
          title: "When?",
          emoji: "📅",
          questionOption: {
            question: "Do you know when you're going?",
            questionType: PlanQuestionType.Dates,
          },
        },
        {
          type: ModuleType.Poll,
          doneType: ModuleDoneType.Voting,
          title: "Activities",
          emoji: "🤩",
        },
        {
          type: ModuleType.Expense,
          doneType: ModuleDoneType.None,
          title: "Expenses",
          emoji: "💰",
        },
      ],
    },
  ],
};
